import { DESIGN_TOKEN } from "Config/design_token";
import { TABLET_LAYOUT, DESKTOP_LAYOUT } from "./constants";

const block = ".wp-block-sandpiper-schedule";

/** Styles that correspond to the Sandpiper Schedule Wordpress block. */
export const SCHEDULE_STYLES = `
  ${block} {
    display: flex;
    width: 100%;
    flex-direction: column;
    margin-bottom: 2rem;
  }
  ${block}:last-of-type {
    margin-bottom: 0rem;
  }
  ${DESKTOP_LAYOUT} ${block} {
    max-width: 52rem;
  }

  ${block}__title {
    font-size: 1.6rem;
    line-height: 1.8rem;
    padding-bottom: 0rem;
    border: none;
  }
  ${TABLET_LAYOUT} ${block}__title,
  ${DESKTOP_LAYOUT} ${block}__title {
    text-align: center;
  }

  ${block}__dates {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
  }
  ${TABLET_LAYOUT} ${block}__dates,
  ${DESKTOP_LAYOUT} ${block}__dates {
    flex-direction: row;
    border-top: none;
    border-right: thin solid ${DESIGN_TOKEN.colors.swatch_5};
    border-bottom: thin solid ${DESIGN_TOKEN.colors.swatch_5};
    border-left: thin solid ${DESIGN_TOKEN.colors.swatch_5};
  }

  ${block}__dates__title {
    padding: 0.25rem 1rem;
    border-bottom: thin solid ${DESIGN_TOKEN.colors.swatch_5};
    background-color: ${DESIGN_TOKEN.colors.swatch_1};

    font-family: ${DESIGN_TOKEN.fonts.font_2.family};
    font-weight:  ${DESIGN_TOKEN.fonts.font_2.weight.semibold};
    line-height: 1.4rem;
    color: ${DESIGN_TOKEN.colors.swatch_3};
  }
  ${TABLET_LAYOUT} ${block}__dates__title,
  ${DESKTOP_LAYOUT} ${block}__dates__title {
    flex-shrink: 0;
    flex-basis: 12rem;
    padding: 1.2rem 1rem 1rem 1rem;
    border-bottom: none;
    border-top: thin solid ${DESIGN_TOKEN.colors.swatch_5};

    text-align: right;
    color: ${DESIGN_TOKEN.colors.swatch_2};
    background: none;
  }

  ${block}__dates__description {
    margin-bottom: 1rem;
    padding: 1rem 1rem 2rem 1rem;
    border: thin solid ${DESIGN_TOKEN.colors.swatch_5};
    border-top: none;

    p {
      margin-bottom: 1rem;
      font-size: 1.2rem;
      line-height: 1.8rem;
    }
    p:last-of-type {
      margin-bottom: 0rem;
    }
  }
  ${TABLET_LAYOUT} ${block}__dates__description,
  ${DESKTOP_LAYOUT} ${block}__dates__description {
    margin-bottom: 0rem;
    padding: 1rem;
    flex-basis: calc(100% - 12rem);
    border-top: thin solid ${DESIGN_TOKEN.colors.swatch_5};
    border-right: none;
    border-bottom: none;
    border-left: thin solid ${DESIGN_TOKEN.colors.swatch_5};
  }
`;
